import styled from 'styled-components';

import { spacing } from 'ui/theme';
import { ExpandModes, ExpansionContextProvider } from 'utils/contexts/expansion';

import { Title } from './Title';
import { ExternalId } from './ExternalId';
import { SecondaryDetails } from './SecondaryDetails';
import { useUserMetadataQueryContext } from '../../contexts/UserMetadataQueryContext';
import { GridArea, AUDIENCE_USERPROFILE_SLIDEOVER_KEY } from '../constants';

const Wrapper = styled.ul`
  margin: 0 ${spacing.double};
  min-width: 0;
  flex-grow: 1;
  list-style: none;
  padding: 0;
  grid-area: ${GridArea.contactDetails};
`;

export const ContactDetails = () => {
  const { isLoading, externalUserId, phoneNumber, location, clientType, clientName } =
    useUserMetadataQueryContext();
  return (
    <Wrapper data-test="contact-details-list">
      <ExpansionContextProvider
        localKey={AUDIENCE_USERPROFILE_SLIDEOVER_KEY}
        initialMode={ExpandModes.collapse}
      >
        <Title />
      </ExpansionContextProvider>
      <ExternalId isLoading={isLoading} externalId={externalUserId} />
      <SecondaryDetails
        isLoading={isLoading}
        clientType={clientType}
        clientName={clientName}
        location={location}
        phoneNumber={phoneNumber}
      />
    </Wrapper>
  );
};
